export default "__VITE_ASSET___dQI0_O1__"